/* LumaVibes: keep the Shop Pay installments widget on the variant the visitor
   actually selected. The custom product sections swap the hidden input's value
   from JS, which Shopify's shop-js does not observe, so without this the widget
   would stay on the variant the page was rendered with and quote the wrong sum. */
(function(){
  function apply(form,id){
    if(!id)return;
    var t=form.querySelector('shopify-payment-terms');
    if(!t)return;
    if(t.getAttribute('variant-id')===String(id))return;
    t.setAttribute('variant-id',String(id));
    form.setAttribute('data-variant-id',String(id));
  }
  function watch(form){
    var input=form.querySelector('input[name="id"]');
    if(!input||input.getAttribute('data-lvterms')==='1')return;
    input.setAttribute('data-lvterms','1');
    apply(form,input.value);
    // Sections assign input.value directly, which raises no event: hook the
    // property on this one element, and keep a slow poll as a safety net.
    var d=Object.getOwnPropertyDescriptor(HTMLInputElement.prototype,'value');
    if(d&&d.get&&d.set){
      try{
        Object.defineProperty(input,'value',{configurable:true,
          get:function(){return d.get.call(this);},
          set:function(v){d.set.call(this,v);apply(form,v);}});
      }catch(e){}
    }
    input.addEventListener('change',function(){apply(form,input.value);});
    var last=input.value;
    setInterval(function(){
      if(input.value!==last){last=input.value;apply(form,input.value);}
    },400);
  }
  function init(){
    var forms=document.querySelectorAll('form[action*="/cart/add"]');
    Array.prototype.forEach.call(forms,function(f){
      if(f.querySelector('shopify-payment-terms'))watch(f);
    });
  }
  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',init);
  }else{init();}
  document.addEventListener('shopify:section:load',init);
})();
